// Tiny Markdown renderer — enough for policy text (## headings, **bold**, *em*,
// - bullets, numbered lists, inline `code`, and [links](url)). Escapes HTML
// first so admin-authored content can't inject scripts.
export function renderMarkdown(md, { compact = false } = {}) {
  const h2 = compact ? "font-semibold text-base mt-3 mb-1" : "serif text-2xl mt-6 mb-2";
  const h3 = compact ? "font-semibold text-sm mt-3 mb-1" : "serif text-xl mt-4 mb-2";
  const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const lines = esc(md).split("\n");
  const out = [];
  let inUl = false, inOl = false;
  const flush = () => { if (inUl) { out.push("</ul>"); inUl = false; } if (inOl) { out.push("</ol>"); inOl = false; } };
  for (let line of lines) {
    const trimmed = line.trim();
    if (/^#{1,2} (.+)/.test(trimmed))      { flush(); out.push(`<h2 class="${h2}">${trimmed.replace(/^#{1,2} /, "")}</h2>`); continue; }
    if (/^### (.+)/.test(trimmed))     { flush(); out.push(`<h3 class="${h3}">${trimmed.replace(/^### /, "")}</h3>`); continue; }
    if (/^- (.+)/.test(trimmed))       { if (!inUl) { flush(); out.push('<ul class="list-disc pl-6 space-y-1 my-2">'); inUl = true; } out.push(`<li>${trimmed.replace(/^- /, "")}</li>`); continue; }
    if (/^\d+\. (.+)/.test(trimmed))   { if (!inOl) { flush(); out.push('<ol class="list-decimal pl-6 space-y-1 my-2">'); inOl = true; } out.push(`<li>${trimmed.replace(/^\d+\. /, "")}</li>`); continue; }
    if (trimmed === "")                { flush(); continue; }
    flush();
    out.push(`<p class="leading-relaxed my-2">${trimmed}</p>`);
  }
  flush();
  return out.join("\n")
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>")
    .replace(/`([^`]+)`/g, '<code class="mono text-xs bg-muted/60 rounded px-1 py-0.5">$1</code>')
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-primary underline underline-offset-2">$1</a>');
}

